import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './Context/AuthProvider';
import './Interceptors/axios'

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { UserProvider } from './App/copmponents/UserProvider';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    {/* <UserProvider> */}
  <App />
  {/* </UserProvider> */}
  </AuthProvider>
);
serviceWorkerRegistration.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


// let deferredPrompt;

// window.addEventListener('beforeinstallprompt', (e) => {
//   e.preventDefault();
//   deferredPrompt = e;
//   const installButton = document.getElementById('install-button');
//   if (installButton) {
//     installButton.style.display = 'block';
//   }
// });

// const installButton = document.getElementById('install-button');
// if (installButton) {
//   installButton.addEventListener('click', () => {
//     deferredPrompt.prompt();

//     deferredPrompt.userChoice.then((choiceResult) => {
//       if (choiceResult.outcome === 'accepted') {
//         console.log('המשתמש קיבל את ההתקנה');
//       } else {
//         console.log('המשתמש דחה את ההתקנה');
//       }
//       deferredPrompt = null;
//     });
//   });
// }